import React from 'react'

const cards = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2']

const Card = ({
  suit: cardSuit = 'h',
  hand = [0, 2],
  index: indexString = 0,
}) => {
  const index = parseInt(indexString)

  const suits = {
    c: '♣',
    // c: club(),
    s: '♠',
    // s: spade(),
    d: '♦',
    // d: diamond(),
    h: '♥',
    // h: heart(),
  }

  const handIndex = hand[index] || 0

  const suit = cardSuit
  const cardLabel = `${cards[handIndex]}` || 'A'

  const suitColor = Object.keys(suits).indexOf(suit) < 2 ? 'black' : 'red'

  return (
    <div
      style={{
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'white',
        borderColor: '#DFE3E6',
        borderRadius: 2,
        width: '33px',
        height: '45px',
        transform: `rotate(${index === 0 ? -8 : 8}deg)`,
      }}
    >
      <p
        style={{
          fontSize: '12px',
          fontWeight: '500',
          padding: 0,
          margin: 0,
        }}
      >
        {cardLabel}
      </p>
      <div style={{ color: suitColor }}>{suits[suit]}</div>
    </div>
  )
}

export default Card
